import {LitElement, html, css, nothing} from 'lit';

export class ProjectAddTagElement extends LitElement {
    static get styles() {
        return css`
        :host {
            display: flex;
            padding:0;
            margin:0;
            color: #959595;
            position: relative;
            margin-right: 0.8em;
            margin-bottom: 0.8em;
        }
        .tag-element {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            padding-left: 0.8em;
            padding-right: 0.8em;
            background-color: #333;
            border: 2px dashed #444;
            border-radius: 3px;
            font-weight: bold;
            cursor: pointer;
            text-decoration: none;
        }
        .tag-element--verified {
            border-style: solid;
        }
        .tag-element--universe {
            background-color: #1e3416;
        }
        .tag-element--character {
            background-color: #17334a;
        }
        .tag-element--software {
            background-color: #350606;
        }
        .tag-element--misc {
            background-color: #333;
        }
        .tag-element-type {
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 100%;
        }
        .tag-element-name {
            color: #FFF;
            margin-right: 0.3em;
        }
        .tag-element-count {
            margin-right: 0.3em;
        }
        .tag-element-optionbutton {
            color: #aaa;
            padding-top: 0.5em;
            padding-right: 0.5em;
            padding-bottom: 0.5em;
        }
        .tag-element-optionbutton:hover {
            color: #FFF;
        }
        .tag-element-type svg {
            width: 16px;
            height: 16px;
            fill: #FFF;
        }
        .tag-input {
            position: absolute;
            left: 0;
            top: 1.85em;
            background-color: #333;
            border: 1px solid #444;
            z-index: 2;
            border-radius: 3px;
        }
        .tag-element-options ul {
            list-style: none;
            padding: 0;
        }
        
        input.tag-element-option {
            color: #FFF;
            background-color: #444;
            border: none;
        }

        .tag-element-option {
            display: flex;
            flex-direction: row;
            margin-left: 0;
            min-width: 300px;
            box-shadow: 0 0 0 1px #333;
            padding: 0.5em;
        }
        .tag-element-option:hover, .tag-element-option--focus {
            color: #FFF;
            background-color: #444;
            cursor: pointer;
        }
        .tag-element-option:first-child {
            border-top-left-radius: 3px;
            border-top-right-radius: 3px;
        }
        .tag-element-option:last-child {
            border-bottom-left-radius: 3px;
            border-bottom-right-radius: 3px;
        }
        .tag-element-option svg {
            width: 20px;
            height: 20px;
            fill: #959595;
            margin-right: 0.5em;
        }
        `;
    }
    
    static get properties() {
        return {
            projectid: {type: Number},
            type: {type: String},
            expanded: {type: Boolean},
            searchTerm: {type: String},
            searchSuggestionTagArray: {type: Array},
            searchSelectionIndex: {type: Number}
        };
    }

    constructor() {
        super();
        this.projectid = 0;
        this.type = '';
        this.expanded = false;
        this.searchTerm = '';
        this.searchSuggestionTagArray = [];
        this.searchSelectionIndex = 0;
    }

    getIcon() {
        return html`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M432 256c0 17.69-14.33 32.01-32 32.01H256v144c0 17.69-14.33 31.99-32 31.99s-32-14.3-32-31.99v-144H48c-17.67 0-32-14.32-32-32.01s14.33-31.99 32-31.99H192v-144c0-17.69 14.33-32.01 32-32.01s32 14.32 32 32.01v144h144C417.7 224 432 238.3 432 256z"/></svg>`;
    }

    _addTag(e) {
        e.preventDefault();
        let target = e.target;
        if (target.tagName === 'SPAN') {
            target = target.parentElement;
        }
        let tagId = e.target.dataset.tagId;
        this._dispatchTagAdd(tagId);
    }

    _dispatchTagAdd(tagId) {
        let tag = this.searchSuggestionTagArray.find(tag => tag.id == tagId);
        this.dispatchEvent(new CustomEvent('addtag', {
            bubbles: true,
            composed: true,
            detail: {
                projectid: this.projectid,
                tag: tag
            }
        }));
        this._resetElement();
    }

    _dispatchNewTagAdd(tagname) {
        this.dispatchEvent(new CustomEvent('addnewtag', {
            bubbles: true,
            composed: true,
            detail: {
                projectid: this.projectid,
                tagname: tagname,
                type: this.type,
            }
        }));
        this._resetElement();
    }

    _resetElement() {
        this.searchTerm = '';
        this.searchSelectionIndex = 0;
        this.searchSuggestionTagArray = [];
        this.expanded = false;
    }
    
    _fetchTagList() {
        this.searchSuggestionTagArray = [];
        let searchParam = this.searchTerm ? `&search=${this.searchTerm}` : '';
        if (this.type == 'universe') {
            var tagUrl = '/api/tag/property/?format=json' + searchParam;
        }
        if (this.type == 'character') {
            var tagUrl = '/api/tag/character/?format=json' + searchParam;
        }
        if (this.type == 'software') {
            var tagUrl = '/api/tag/software/?format=json' + searchParam;
        }
        if (this.type == 'misc') {
            var tagUrl = '/api/tag/misc/?format=json' + searchParam;
        }

        console.log(tagUrl);

        var myInit = {
            method: 'GET'
        };

        var myRequest = new Request(tagUrl, myInit);

        fetch(myRequest).then(
            responseData => responseData.json()
        ).then(
            responseData => {
                if (responseData.count > 0 && responseData.results.length > 0) {
                    this.searchSuggestionTagArray = responseData.results;
                    this.searchSelectionIndex = 0;
                }
            }
        ).catch(function (e) {
            console.log(e);
        });
        this.requestUpdate();
    }

    _onBlur() {
        this.expanded = false;
        this._resetElement();
    }

    renderTagModal() {
        if (this.expanded) {
            return html`
                <div class="tag-input">
                    <input type="text" placeholder="Tag name" id="tag-input" class="tag-element-option tag-input-field" @keyup="${this._inputChange}" @blur="${this._onBlur}">
                    <div class="tag-element-options">
                        <ul>
                            ${this.renderTagElements()}
                        </ul>
                    </div>
                </div>
            `;
        }
    }

    renderTagElement(tag, selected) {
        return html`
            <li class="tag-element-option${selected ? ' tag-element-option--focus' : ''}" data-tag-id="${tag.id}" @click="${this._addTag}">
                <span class="tag-element-name">${tag.name}</span>
            </li>
        `;
    }

    renderTagElements() {
        let tagElements = [];
        if (this.searchSuggestionTagArray.length > 0) {
            for (let i = 0; i < this.searchSuggestionTagArray.length; i++) {
                tagElements[i] = this.renderTagElement(this.searchSuggestionTagArray[i], this.searchSelectionIndex == i);
            }
        } else {
            tagElements = [html`<li class="tag-element-option">No tags found</li>`];
        }
        return tagElements;
    }

    async openModal(e) {
        this.expanded = !this.expanded;
        await this.updateComplete;
        let inputElement = this.shadowRoot.querySelector('#tag-input');
        if (inputElement) {
            inputElement.focus();
        }
    }

    _inputChange(e) {
        let inputField = e.target;
        this.searchTerm = inputField.value;
        // Enter pressed, tag exists, submit tag
        if (e.keyCode === 13 && this.searchTerm.length > 0 && this.searchSuggestionTagArray.length > 0) {
            this._dispatchTagAdd(this.searchSuggestionTagArray[this.searchSelectionIndex].id);
        }

        if (e.keyCode === 13 && this.searchTerm.length > 0) {
            this._dispatchNewTagAdd(this.searchTerm);
        }

        // Down
        if (e.keyCode == 40) {
            if (this.searchSelectionIndex < this.searchSuggestionTagArray.length - 1) {
                this.searchSelectionIndex++;
                this.requestUpdate();
            }
            return;
        }
        // Up
        if (e.keyCode == 38) {
            if (this.searchSelectionIndex > -1 && this.searchSuggestionTagArray.length > 0) {
                this.searchSelectionIndex--;
                this.requestUpdate();
            }
            return;
        }

        // Any other key change in the search term
        if (this.searchTerm != '' && e.keyCode != 13) {
            this._fetchTagList();
        }
    }

    render() {
        return html`
            <div class="tag-element tag-element--${this.type} tag-element--verified" @click="${this.openModal}">
                <span class="tag-element-type">${this.getIcon()}</span>
            </div>
            ${this.renderTagModal()}
        `;
    }
}

window.customElements.define('project-add-tag-element', ProjectAddTagElement);